import { Col3Col9 } from '@aon/aon-tws-common-ui';
import React, { useEffect, useState } from 'react';
import ContentConstants from '../../../../contentConstants';
import { IPageFlowElementModel } from '../../../../models';
import { PageFlowElementModalUtil } from '../../../../utilities/PageFlowElementModalUtil';
import { PageFlowQuestionSection } from '../PageFlowQuestionSection';
import { IPageFlowElementModalProps, PageFlowElementModal } from './PageFlowElementModal';

export const SectionBreakModal = (props: IPageFlowElementModalProps) => {
	const title = props.pageFlowElement
		? ContentConstants.LOGIC_AND_LAYOUT.EDIT_SECTION_BREAK
		: ContentConstants.LOGIC_AND_LAYOUT.ADD_SECTION_BREAK;

	useEffect(() => {
		PageFlowElementModalUtil.HandleEffect(props, setQuestionId, setQuestionError, setSurveyElement);
		return setDefaultState;
	}, [props.pageFlowElement, props.questions, props.maxId, props.isOpen]);

	const [questionId, setQuestionId] = useState('');
	const [surveyElement, setSurveyElement] = useState<IPageFlowElementModel>(PageFlowElementModalUtil.InitializeSurveyElement(props));
	const [questionError, setQuestionError] = useState(false);
	const [questionList, setQuestionList] = useState(PageFlowElementModalUtil.InitializeQuestionList(props, true));

	const setDefaultState = () => {
		PageFlowElementModalUtil.SetDefaultState(props, setQuestionId, setQuestionError, setSurveyElement, setQuestionList, true);
	};

	const handleSubmit = () => {
		return PageFlowElementModalUtil.HandleSubmit(
			props,
			questionId,
			surveyElement,
			setQuestionError,
			setSurveyElement,
			PageFlowElementModalUtil.IsValid,
		);
	};

	const handleClose = () => {
		PageFlowElementModalUtil.HandleClose(setDefaultState, props.onClose);
	};

	return (
		<PageFlowElementModal
			{...props}
			title={title}
			onSubmit={handleSubmit}
			onClose={handleClose}
			contentFullWidth={false}
			modalType='lightbox'
		>
			<Col3Col9 label={ContentConstants.LOGIC_AND_LAYOUT.BEFORE_QUESTION} className='tws-question-row'>
				<PageFlowQuestionSection
					questions={questionList}
					questionError={questionError}
					questionId={questionId}
					handleQuestionChange={(value: any) => PageFlowElementModalUtil.HandleQuestionChange(value, setQuestionId, setQuestionError)}
				/>
			</Col3Col9>
		</PageFlowElementModal>
	);
};
